(() => {
  const initializeCounters = (root = document) => {
    root.querySelectorAll('.contact-form-editorial').forEach((section) => {
      const message = section.querySelector('.contact-form-textarea');
      const count = section.querySelector('[data-character-count]');

      if (!message || !count || message.dataset.counterInitialized === 'true') return;

      const updateCount = () => {
        if (message.maxLength > -1 && message.value.length > message.maxLength) {
          message.value = message.value.slice(0, message.maxLength);
        }

        count.textContent = message.value.length;
      };

      message.dataset.counterInitialized = 'true';
      message.addEventListener('input', updateCount);
      updateCount();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCounters(), { once: true });
  } else {
    initializeCounters();
  }

  document.addEventListener('shopify:section:load', (event) => initializeCounters(event.target));
})();
